<template>
  <div class="floating-sidebar">
    <div class="sidebar-widget">
      <img
        :src="sidebarImg"
        alt="在线咨询"
        class="sidebar-img"
        draggable="false"
      />

      <div class="consult-zone">
        <button
          type="button"
          class="hit-area consult-hit"
          aria-label="在线咨询"
          @mouseenter="handleConsultEnter"
          @mouseleave="handleConsultLeave"
          @click="handleConsultClick"
        />

        <transition name="fade">
          <div
            v-if="showConsult"
            class="consult-popup"
            @mouseenter="handleConsultEnter"
            @mouseleave="handleConsultLeave"
          >
            <img
              :src="consultQrImg"
              alt="在线咨询 - 扫码添加微信"
              class="consult-popup-img"
              draggable="false"
            />
          </div>
        </transition>
      </div>

      <button
        type="button"
        class="hit-area message-hit"
        aria-label="留言咨询"
        @click="openRequirement"
      />
    </div>

    <div v-show="showBackTop" class="back-top-btn" @click="scrollToTop">
      <i class="el-icon-top"></i>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import sidebarImg from '@/assets/images/floating-sidebar.png'
import consultQrImg from '@/assets/images/consult-qr-popup.png'

export default {
  name: 'FloatingSidebar',
  data() {
    return {
      sidebarImg,
      consultQrImg,
      showConsult: false,
      showBackTop: false,
      consultPinned: false,
      consultLeaveTimer: null
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    this.clearConsultLeaveTimer()
  },
  methods: {
    ...mapActions(['openRequirementDialog']),
    handleScroll() {
      this.showBackTop = window.scrollY > 300
    },
    openRequirement() {
      this.openRequirementDialog()
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    clearConsultLeaveTimer() {
      if (this.consultLeaveTimer) {
        clearTimeout(this.consultLeaveTimer)
        this.consultLeaveTimer = null
      }
    },
    handleConsultEnter() {
      this.clearConsultLeaveTimer()
      if (window.innerWidth > 768) {
        this.consultPinned = false
        this.showConsult = true
      }
    },
    handleConsultClick() {
      this.clearConsultLeaveTimer()
      this.consultPinned = !this.showConsult
      this.showConsult = !this.showConsult
    },
    handleConsultLeave() {
      if (window.innerWidth <= 768 || this.consultPinned) {
        return
      }
      this.clearConsultLeaveTimer()
      this.consultLeaveTimer = setTimeout(() => {
        this.showConsult = false
        this.consultLeaveTimer = null
      }, 200)
    }
  }
}
</script>

<style lang="scss" scoped>
.floating-sidebar {
  position: fixed;
  right: 16px;
  bottom: 80px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.sidebar-widget {
  position: relative;
  width: 60px;
  line-height: 0;
  overflow: visible;
}

.sidebar-img {
  width: 100%;
  height: auto;
  display: block;
  user-select: none;
  pointer-events: none;
}

.hit-area {
  position: absolute;
  left: 18%;
  width: 64%;
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;
  z-index: 2;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
  }
}

.consult-zone {
  position: absolute;
  left: 18%;
  width: 64%;
  top: 40%;
  height: 24%;
  z-index: 2;
}

.consult-hit {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 4px 4px 0 0;
}

.message-hit {
  top: 66%;
  height: 24%;
  border-radius: 0 0 4px 4px;
}

.consult-popup {
  position: absolute;
  z-index: 10;
  right: calc(100% + 12px);
  bottom: 0;
  width: 255px;
  line-height: 0;
  pointer-events: auto;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: -12px;
    width: 12px;
    height: 100%;
  }
}

.consult-popup-img {
  width: 255px;
  max-width: none;
  height: auto;
  display: block;
  user-select: none;
  filter: drop-shadow(0 4px 16px rgba(0, 0, 0, 0.15));
}

.back-top-btn {
  width: 40px;
  height: 40px;
  background: $white;
  border-radius: 50%;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: $transition;
  color: $primary-color;
  font-size: 18px;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 102, 255, 0.2);
    color: $accent-color;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .floating-sidebar {
    right: 10px;
    bottom: 60px;
  }

  .sidebar-widget {
    width: 52px;
  }

  .consult-popup {
    right: calc(100% + 8px);
    width: 220px;
  }

  .consult-popup-img {
    width: 220px;
    max-width: none;
  }
}
</style>
